module.exports = __webpack_public_path__ + "static/media/pizza.73beb221.png";